import {
  AutociteMetadataInput,
  AutociteClientCommonFieldInput,
} from '@chegg-wt/core/globalTypesOneGraph'
import { SUBMIT_AUTOCITE_METADATA } from '../oneGraphQueries/PlusCiteRioEvent'
import {
  SubmitAutociteMetadata,
  SubmitAutociteMetadataVariables,
} from '../oneGraphQueries/__generated__/SubmitAutociteMetadata'
import { client } from './graphApi'

export const sendPlusCiteRioEvent = (
  autociteResponse: AutociteMetadataInput,
  numFieldsAutocite: number,
  trackingId: string,
  clientCommonField: AutociteClientCommonFieldInput
) => {
  client.mutate<SubmitAutociteMetadata, SubmitAutociteMetadataVariables>({
    mutation: SUBMIT_AUTOCITE_METADATA,
    variables: {
      request: {
        autociteResponse,
        numFieldsAutocite,
        trackingId,
        clientCommonField,
      },
    },
    context: {
      clientName: 'oneGraph',
    },
  })
}
